module.exports = require("http");


//////////////////
// WEBPACK FOOTER
// external "http"
// module id = http
// module chunks = 5